import { useEffect, useRef } from '@bpmn-io/properties-panel/preact/hooks';

export const useMountRef = () => {
    const mountRef = useRef(false);

    useEffect(() => {
        mountRef.current = true;
        return () => {
            mountRef.current = false;
        };
    }, []);

    return mountRef;
};
